module.exports = require("./ff-Latn.d.ts");